import script from "./mainBox.vue?vue&type=script&setup=true&lang=js"
export * from "./mainBox.vue?vue&type=script&setup=true&lang=js"

import "./mainBox.vue?vue&type=style&index=0&id=8ce1b92e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ce1b92e"]])

export default __exports__